import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/index.vue'
import Show from '../pages/show.vue'
import Login from '../pages/login.vue'
import Analysis from '../pages/analysis.vue'
// import Result from '../pages/result_single.vue'
import Result from '../pages/result_multiple.vue'
// import Result from '../pages/result/index.vue'
import View from '../pages/view.vue'
import detail from '../pages/detail.vue'
import center from '../pages/center.vue'

// 新增页面
import NewHome from '../pages/home'
import WenKu from '../pages/wenku'
import personal from '../pages/uc'

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/show',
      name: 'Show',
      component: Show
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/analysis',
      name: 'Analysis',
      component: Analysis
    },
    {
      path: '/result',
      name: 'Result',
      component: Result
    },
    // {
    //   path: '/resultold',
    //   name: 'ResultOld',
    //   component: ResultOld
    // },
    {
      path: '/view',
      name: 'View',
      component: View
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/center',
      name: 'center',
      component: center
    },
    {
      path: '/',
      name: 'NewHome',
      component: NewHome
    },
    {
      path: '/wenku',
      name: 'WenKu',
      component: WenKu
    },
    {
      path: '/personal',
      name: 'Personal',
      component: personal
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js